(ns basic-components.inputs.url
  (:require
   [basic-components.inputs.footprint :refer [display-string editor viewer]]
   [clojure.string :as string]
   [common.url :as url]
   [frontend.utils :as fu]
   [reagent.core :as r]))

(defn render
  [dom-atom args]
  (let [{:keys [value placeholder class-name
                has-focus? cursor-at-end-on-focus? select-all-on-focus?
                on-focus! on-blur! on-change!
                on-key-down! disabled? auto-focus]}
        args
        edit-value (or (:temp-value @dom-atom) value)
        render-value (str (if (nil? edit-value) value edit-value))
        clear-state! (fn []
                       (swap! dom-atom dissoc :temp-value))]
    [:input
     (merge {:ref         (fn [e]
                            (when (and e
                                       (not= e (:input-dom-node @dom-atom)))
                              (swap! dom-atom assoc :input-dom-node e)))
             :placeholder (or placeholder "")
             :class-name  (fu/cs "input-area" (when has-focus? "focus") class-name)
             :value       render-value
             :on-focus    (fn [e]
                            (swap! dom-atom assoc :focus? true)
                            (fu/timeout 50                  ;; must do this in timeout since focus may be called before mount
                                        (fn []
                                          (cond cursor-at-end-on-focus?
                                                (fu/put-cursor-at-end! dom-atom)
                                                :else       ;TODO - add select-all-on-focus?
                                                (.select (:input-dom-node @dom-atom)))))
                            (when on-focus!
                              (on-focus! e)))
             :on-change   (fn [e]
                            (let [new-value (-> e
                                                .-target
                                                .-value
                                                (url/string->protocol-url :https))]
                              (swap! dom-atom assoc :temp-value new-value)
                              (when on-change!
                                (on-change! e new-value))))
             :on-blur     (fn [e]
                            (when on-blur!
                              (on-blur! e render-value clear-state!)))
             :on-key-down on-key-down!
             :auto-focus  (boolean auto-focus)}
            (when disabled?
              {:disabled true}))]))

(defmethod editor :editor.type/url
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]                        ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Url"
      :component-did-mount    (fn [args]
                                (let []
                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc :temp-value)))) ;; save complete -> reset temp state
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (render dom-atom args))})))

(defmethod display-string :editor.type/url
  [args]
  (:value args))

(defmethod viewer :editor.type/url
  [args]
  (r/create-class
   {:display-name   "url/viewer"
    :reagent-render (fn [args]
                      (when (and args (:value args))
                        (let [value (:value args)
                              href-value (when-not (string/blank? (str value))
                                           (url/relative-or-protocol-url (str value) :https))]
                          [:div.input-text-viewer
                           ^{:key (str "URL-viewer" (rand-int 1000000))}
                           (if (string/blank? (str value))
                             "-"
                             [:a.input-text-viewer__link
                              {:href   href-value
                               :target "_blank"}
                              value])])))}))
